export default {
  PRINTABLE: "printable",
  VIDEO: "video",
  POLL: "poll",
};
